// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"fa062c9b","145":"7d7e270f","401":"79a27d1c","870":"8c125c3f"}[chunkId] + ".chunk.css";
};